import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AnnouncementDTO } from "./GetAllAnnouncements";
type AddAnnouncementDTO = {
    isPin:boolean
};

type AnnouncementResponse  = AnnouncementDTO & ApiError;

export const EditAnnouncement = (data: AddAnnouncementDTO , id:string): Promise<AnnouncementResponse> => {
    return axios.patch(`/announcement/${id}`, data)
        .then(response => response.data as AnnouncementResponse);
};